import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { Moment } from 'moment-timezone'

export const datesRangeSelector: Selector<ReduxState, [Moment | null, Moment]> = state => state.processingCosts.datesRange
export default datesRangeSelector